<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" title="Volver" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" type="submit" title="Guardar" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4>{{editTitle}} Exportador</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <!--<a class="card-header-a" (click)="isCollapsedEntidad = !isCollapsedEntidad"
                       [attr.aria-expanded]="!isCollapsedEntidad" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos Principales
                            <i *ngIf="isCollapsedEntidad" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedEntidad" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>-->

                    <div class="card-body">

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpNIF">NIF/EORI</label>
                                <input formControlName="NIF" name="NIF" title=""
                                       class="form-control" id="inpNombre" type="text" value="" [ngClass]="displayFieldCss('NIF')" maxlength="17">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('NIF','required')">
                                    NIF/EORI es obligatorio
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIF','NIF')">
                                    Formato de NIF/EORI incorrecto
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NIF','NIF_duplicated')">
                                    El NIF ya existe en la base de datos
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpRazonSocial">Razón Social</label>
                                <input formControlName="RazonSocial" name="RazonSocial" title=""
                                       class="form-control" id="inpNombre" type="text" value="" [ngClass]="displayFieldCss('RazonSocial')" maxlength="150">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('RazonSocial','required')">
                                    Razón Social es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="inpDireccion">Dirección</label>
                                <input formControlName="Direccion" name="Direccion" title=""
                                       class="form-control" id="inpDireccion" type="text" value="" [ngClass]="displayFieldCss('Direccion')" maxlength="150">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Direccion','required')">
                                    Dirección es obligatorio
                                </div>
                            </div>


                        </div>

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="">País</label>
                                <ng-select loadingText="Cargando..."
                                           [items]="listPais"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdPais"
                                           [readonly]="!listPais || listPais.length === 0"
                                           [loading]="!listPais || listPais.length === 0"
                                           notFoundText="País no encontrado"
                                           [ngClass]="displayFieldCssNgSelect('IdPais')"
                                           placeholder="-- Seleccione un País --"
                                           clearAllText="Eliminar selección"
                                           (change)="onSelectPais()">
                                </ng-select>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPais','required')">
                                    País es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="intProvincia" [ngClass]="{ 'required-field' : isEspania() }">Provincia</label>
                                <ng-select loadingText="Cargando..."
                                           [items]="listProvincia"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdProvincia"
                                           [readonly]="!listProvincia || listProvincia.length === 0"
                                           [loading]="(!listProvincia || listProvincia.length === 0) && isEspania()"
                                           notFoundText="Provincia no encontrada"
                                           [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                           placeholder="-- Seleccione una Provincia --"
                                           clearAllText="Eliminar selección"
                                           (change)="onSelectProvincia()">
                                </ng-select>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdProvincia','required')">
                                    Provincia es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpIdMunicipio" [ngClass]="{ 'required-field' : isEspania() }">Municipio</label>
                                <ng-select loadingText="Cargando..."
                                           [items]="listMunicipio"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdMunicipio"
                                           [loading]="(!listMunicipio || listMunicipio.length === 0) && form.value.IdProvincia > 0"
                                           notFoundText="Municipio no encontrado"
                                           [ngClass]="displayFieldCssNgSelect('IdMunicipio')"
                                           placeholder="-- Seleccione una Municipio --"
                                           clearAllText="Eliminar selección">
                                </ng-select>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdMunicipio','required')">
                                    Municipio es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpCodigoPostal">Código Postal</label>
                                <input formControlName="CodigoZip" name="CodigoZip" title="" numbersOnly
                                       class="form-control" id="inpCodigoPostal" type="text" value="" [ngClass]="displayFieldCss('CodigoZip')" maxlength="5">
                                <div class="invalid-feedback" *ngIf="isFieldInvalid('CodigoZip','required')">
                                    Código Postal es obligatorio
                                </div>
                            </div>

                        </div>


                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpFechaAlta">Fecha Alta</label>
                                <p-calendar formControlName="FechaAlta" inputStyleClass="form-control" [ngClass]="displayFieldCssCal('FechaAlta')"
                                            [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                            </div>


                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFechaAlta">Fecha Baja</label>
                                <p-calendar formControlName="FechaBaja" inputStyleClass="form-control" [ngClass]="displayFieldCssCal('FechaBaja')"
                                            [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpFechaAlta">Fecha Caducidad Baja</label>
                                <p-calendar formControlName="FechaCaducidadBaja" inputStyleClass="form-control" [ngClass]="displayFieldCssCal('FechaCaducidadBaja')"
                                            [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label required-field" for="inpFechaAlta">Fecha Última Exportación</label>
                                <p-calendar formControlName="FechaUltimaExportacion" inputStyleClass="form-control" [ngClass]="displayFieldCssCal('FechaUltimaExportacion')"
                                            [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>
                            </div>


                        </div>

                        <div class="row">

                            <div class="form-group col-md-4">
                                <label class="col-form-label" for="inpActivo">Activo</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="Activo" onLabel="Sí" offLabel="NO"
                                                onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                            </div>

                        </div>


                        <div class="row">

                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpObservaciones">Observaciones</label>
                                <textarea style="resize:none" formControlName="Observaciones" name="Observaciones" title=""
                                          class="form-control" id="inpObservaciones" type="text" value="" maxlength="5000"></textarea>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</form>
